import { useInitSearch } from "./useInitSearch";

type InitSearchProps = {
    searchFilters?: string;
    query?: string;
    categoryPagePaths?: Array<string>;
};

export const InitSearch = ({
    searchFilters,
    query,
    categoryPagePaths,
}: InitSearchProps) => {
    useInitSearch({
        searchFilters,
        query,
        categoryPagePaths,
    });
    return null;
};
